import { Fragment, useEffect, useRef, useState } from "react";
import {
  formatAddress,
  StringToObject,
} from "../../../../Layout/Common/common";
import {
  addressLine1Keys,
  addressToKeys,
  BILLINFO_SHIPMETHOD,
  contactLineKeys,
} from "../../../../constants";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

export const ShippingAddress = ({ params }) => {
  const [shipData, setShipData] = useState();
  const [billAddress, setBillAddress] = useState(null);
  const [shipAddress, setShipAddress] = useState(null);
  const [shipMethod, setShipMethod] = useState(null);
  const history = useNavigate();
  const divcontainerRef = useRef();
    useEffect(() => {
    if (params) {
      if (params.deliveryAddress) setBillAddress(params.deliveryAddress);
      if (params.shippingAddress) setShipAddress(params.shippingAddress);
      if (params.shipMethod)
        setShipMethod(
          BILLINFO_SHIPMETHOD[StringToObject(params.shipMethod)] ||
            params.shipMethod
        );
    }
  }, [params]);
  return (
    <div className="col-md-6" ref={divcontainerRef}>
      {/* Billing & Shipping Address*/}
      <div className="order-address">
        <div className="card order-address-card">
          <div className="card-header">
            <h5>
              <span className="wes wes-download" />
              Address
            </h5>
          </div>
          <div className="card-body order-address-body">
            <div className="row">
              <div className="col-sm-6 col-md-6">
                <div className="addressDetails">
                  <h6>Shipping Address</h6>
                  {shipAddress ? (
                    <Fragment>
                      <div
                        className="mt-3"
                        style={{ textTransform: "capitalize" }}
                      >
                        <address>
                          {shipAddress ? (
                            shipAddress["shipTo"]
                          ) : (
                            <Skeleton width={100} />
                          )}
                          <br />
                          {shipAddress ? (
                            formatAddress(shipAddress, [
                              "shipAddress1",
                              "shipAddress2",
                              "shipAddress3",
                              "shipCity",
                            ]).map(
                              (item) =>
                                item && (
                                  <Fragment>
                                    {item},
                                    <br />
                                  </Fragment>
                                )
                            )
                          ) : (
                            <Skeleton width={150} />
                          )}
                          {shipAddress ? (
                            <>
                              {shipAddress.shipState}-{shipAddress.shipZip},{" "}
                              {shipAddress.shipCountry}.
                            </>
                          ) : (
                            <Skeleton width={150} />
                          )}
                          <br />
                        </address>
                      </div>
                      <div className="addressDetails-contact mt-3">
                        {shipAddress && (
                          <Fragment>
                            <p>
                              <b>Phone Number:</b> {shipAddress.shipPhone}
                            </p>
                            <p>
                              <b>Attn To:</b> {shipAddress.shipAttention}
                            </p>
                          </Fragment>
                        )}
                      </div>
                    </Fragment>
                  ) : (
                    <Skeleton />
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6">
                <div
                  className="addressDetails"
                  style={{ textTransform: "capitalize" }}
                >
                  <h6>Billing Address</h6>
                  {billAddress && (
                    <Fragment>
                      <address className="mt-3">
                        <b>{billAddress.billTo},</b>
                        <br />
                        {billAddress.billAttention && (
                          <Fragment>
                            {billAddress.billAttention},<br />
                          </Fragment>
                        )}
                        {billAddress &&
                          formatAddress(billAddress, [
                            "billAddress1",
                            "billAddress2",
                            "billAddress3",
                            "billCity",
                          ]).map(
                            (item) =>
                              item && (
                                <Fragment>
                                  {item},
                                  <br />
                                </Fragment>
                              )
                          )}
                        {billAddress ? (
                          <>
                            {billAddress.billState}-{billAddress.billZip},{" "}
                            {billAddress.billCountry}.
                          </>
                        ) : (
                          <Skeleton width={150} />
                        )}
                      </address>

                      <div className="addressDetails-contact mt-3">
                        <p>
                          <b>Phone Number:</b> {billAddress.billPhone}
                        </p>
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Billing & Shipping Address*/}
    </div>
  );
};
